/* eslint-disable no-unused-vars */
import { BackIcon, NotificationBell } from "../../Icons";
import { Badge, Box, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { DRAWERS } from "../../../config/params";
import { INoticationListState } from "../../../state/notifications";
import { IRootState } from "../../../state";
import { IUserItemResponse } from "../../../services/user-detail/user-detail.interface";
import { InlineImportantHeader } from "../../../styles/styledComponents/Header.styled";
import Loading from "../../Loading/Loading";
import React from "react";
import { layoutPadding } from "../../ContentLayout/ContentLayout.style";
import { useBraze } from "../../../context/BrazeContext";
import { useDrawer } from "../../../context/DrawerContext";
import useNotificationsList from "../../../services/notifications/notifications.service";
import { useSelector } from "react-redux";

interface IPageTitle {
  showBackButton: boolean,
  pageTitle: string,
  user: IUserItemResponse,
  showNotificationIcon:boolean

}

const PageTitle: React.FC<IPageTitle> = (props) => {
  const { showBackButton, pageTitle, user } = props;

  const { loading } = useNotificationsList();
  const { openDrawer } = useDrawer();
  const { unviewedCount } = useBraze();
  const navigate = useNavigate();
  const { notificationsLists } = useSelector((state: IRootState) => state.notications as INoticationListState);
  const location = useLocation();

  const findPreviousPagePath = () => {
    const pathURLs = location.pathname.split("/");
    let previousPathURL="";

    for (let i = 0; i < pathURLs.length-1; i++) {
      if (i!=0)previousPathURL += `/${pathURLs[i]}`;
    }

    return previousPathURL;
  };


  const handleNotificationDrawer = () => {
    openDrawer(DRAWERS.NOTIFICATIONS);
  };

  const handleOnBack = () => {
    navigate(-1);
  };

  return (
    <Box component="section" className="flex w-full justify-between" sx={layoutPadding}>
      <Box className="flex items-center gap-4">
        {showBackButton &&
          <Box
            className="link"
            onClick={handleOnBack}
          >
            <Box>
              <BackIcon width={20} height={20} />
            </Box>
          </Box>
        }
        <Typography variant="h1">
          {location.pathname === "/dashboard" ?
            <>{pageTitle} <InlineImportantHeader>{user.firstName} !</InlineImportantHeader> </> : pageTitle}
        </Typography>
      </Box>

      { props.showNotificationIcon?<IconButton
        onClick={handleNotificationDrawer} sx={{ "&: hover": { background: "transparent" } }}>
        <Badge color="error" badgeContent={loading ? <Loading size={12} /> :
          (notificationsLists?.totalUnreadNotifications || 0) + unviewedCount} max={9} >
          <NotificationBell width={24} height={24} />
        </Badge>
      </IconButton>:<Box></Box> }
    </Box>
  );
};

export default PageTitle;
